import React from 'react';
import {
  Container, Typography, Grid, Card, CardContent, Box, List,
  ListItem, ListItemIcon, ListItemText, Paper, Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InstallDesktopIcon from '@mui/icons-material/InstallDesktop';
import SettingsIcon from '@mui/icons-material/Settings';
import SpeedIcon from '@mui/icons-material/Speed';
import ComputerIcon from '@mui/icons-material/Computer';

const services = [
  'Windows 10 / Windows 11 installation and upgrade',
  'macOS installation and configuration',
  'Linux server and workstation deployment',
  'Automated OS deployment for multiple systems',
  'Business application installation and setup',
  'Microsoft Office / Microsoft 365 apps configuration',
  'Antivirus and security software deployment',
  'Driver installation and device configuration',
  'Group Policy configuration',
  'Windows Autopilot zero-touch provisioning',
  'System imaging and cloning',
  'Software troubleshooting and optimization',
];

const benefits = [
  {
    icon: ComputerIcon,
    title: 'Multi-Platform',
    description: 'Expert installation across Windows, macOS, and Linux environments',
  },
  {
    icon: InstallDesktopIcon,
    title: 'Automated Deployment',
    description: 'Automated OS deployments for 500+ workstations and servers',
  },
  {
    icon: SettingsIcon,
    title: 'Full Configuration',
    description: 'Complete setup including drivers, policies, and business applications',
  },
  {
    icon: SpeedIcon,
    title: 'Fast Turnaround',
    description: 'Efficient deployment processes to minimize your downtime',
  },
];

function SoftwareInstallation() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h2" component="h1" className="gradient-text" sx={{ mb: 3 }}>
            Software Installation & Configuration
          </Typography>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 4 }}>
            Professional OS deployment, software setup, and system configuration for homes and businesses
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2, px: 4, fontSize: '1.2rem',
              background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
              '&:hover': { background: 'linear-gradient(45deg, #3b82f6 30%, #2563eb 90%)' }
            }}
          >
            Book Service
          </Button>
        </Box>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card className="glass-effect card-hover" sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>{benefit.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{benefit.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Paper elevation={3} sx={{ p: 4, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>Services Included</Typography>
          <Grid container spacing={2}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default SoftwareInstallation;
